import React from 'react';
import { Icon, knockTheme, Switch } from '@knockrentals/knock-shared-web-v2';
import { PropertyColumnText } from './PropertyColumnText';

const DEFAULT_HEADER_CELL_STYLE = {
  backgroundColor: knockTheme.palette.background.field,
};

export const STICKY_COLUMN_BORDER = {
  borderRight: `1px solid ${knockTheme.palette.slate[200]}`,
};

export const PROPERTY_COLUMN_STYLE = {
  ...DEFAULT_HEADER_CELL_STYLE,
  width: '256px',
  ...STICKY_COLUMN_BORDER,
};

export const CHANNEL_COLUMN_STYLE = {
  minWidth: '140px',
  ...DEFAULT_HEADER_CELL_STYLE,
};

export const stylesConfig = {
  property: {
    ...STICKY_COLUMN_BORDER,
  },
};

const propertyColumn = {
  id: 'property',
  label: 'Property',
  sortable: true,
  style: PROPERTY_COLUMN_STYLE,
};

const getColumns = (filteredChannels) => {
  const channelColumns = filteredChannels.map((filteredChannel) => ({
    id: filteredChannel.channelId,
    label: filteredChannel.channelName,
    sortable: true,
    style: CHANNEL_COLUMN_STYLE,
  }));

  return [propertyColumn, ...channelColumns];
};

const getColumnRenderers = (filteredChannels, handleChannelOnChange) => {
  const filteredColumnRenders = filteredChannels.reduce(
    (columnRenderMap, filteredChannel) => {
      const columnFieldName = filteredChannel.channelId;

      columnRenderMap[columnFieldName] = (columnData) => {
        const { dataKey, row, value } = columnData;
        const { property } = row;

        return (
          <Switch
            aria-label={filteredChannel.channelName}
            checked={value}
            name={filteredChannel.channelId}
            onChange={handleChannelOnChange(property.id, dataKey)}
            checkedIcon={<Icon name="check-circle-filled" />}
          />
        );
      };
      return columnRenderMap;
    },
    {}
  );

  return {
    property: (columnData) => {
      const { activeChannelCount, name } = columnData.value;
      return (
        <PropertyColumnText
          activeCount={activeChannelCount}
          propertyName={name}
        />
      );
    },
    ...filteredColumnRenders,
  };
};

export const getColumnConfig = ({
  filteredChannels,
  handleChannelOnChange,
}) => {
  const columns = getColumns(filteredChannels);
  const columnRenderers = getColumnRenderers(
    filteredChannels,
    handleChannelOnChange
  );

  return {
    columns,
    columnRenderers,
  };
};
